import React from 'react'
import styles from "./Developers.module.scss";
import DevelopersTabs from 'component/developerTabs/DeveloperTabs';
import ArrowUpIcon from 'assets/icons/arrowUp';
import { DOCUMENTATION_LINK } from 'lib/Constants';

const Developers = () => {
    return (
        <div className={`${styles.main}`}>
            <div className={`${styles.main__top} flex justify-end`}>
                {/* <span>API Pricing <ArrowUpIcon /></span> */}
                <a href={DOCUMENTATION_LINK} target="_blank" rel="noreferrer">Documentation <ArrowUpIcon /></a>
            </div>
            <DevelopersTabs />
        </div>

    )
}

export default Developers